export const BUILD_INFO = '66b88234'
